import { isAdmin } from "./helpers";
const PricePermissions = {
    prices: {
        index: ({ user }) => isAdmin(user),
    },
};
export default PricePermissions;
